/* Beer Badges product options + price breaks - replaces the Qikify Product Options and AIOD apps (built 25.10.26).
   - Options and price breaks live in assets/bb-options-config.js (window.BB_OPTIONS, keyed by product handle).
   - Choices are saved on the order line as line item properties (the same names Qikify used).
   - Paid extras (discounted sticky pads, pump clip fittings, cutting charge, IGS file, mold) are added as
     nested cart lines under the product, so they are removed with it and their quantity follows it.
   - Price breaks: each product has a "Price break" option with one variant per quantity band.
     The right band is picked automatically from the total quantity of that product in the basket,
     on the product page and whenever the basket changes.
   - Artwork uploads (02.11.26): customers can pick several files at once or add them one by one; each chosen
     file is listed with a remove button and read into memory straight away (files picked from Google Drive /
     Photos / iCloud on phones otherwise fail to send with "Failed to fetch"). The upload is retried once and a
     clear message is shown if it still can't be sent.
   - Large files (02.11.26): Shopify only accepts files up to 20MB in the basket, so customers with bigger files
     (or a WeTransfer / Dropbox / Google Drive link) paste a link instead; it is saved as "Artwork link" and counts
     as their artwork.
   - Loaded on every page by snippets/bb-options.liquid (rendered by sections/bb-options-loader.liquid in the footer group). */
(function () {
  'use strict';
  if (window.__bbOptionsLoaded) return;
  window.__bbOptionsLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var origFetch = window.fetch.bind(window);
  var CFG = window.BB_OPTIONS || {};
  var MAX_FILE = 20 * 1024 * 1024;
  var NET_MSG = "Sorry, your artwork didn't upload. This is usually a weak signal or a file that is stored in the cloud. Please check your connection and press Add to cart again, or email your artwork to sales@beerbadges.co.uk and we'll sort it for you.";

  (function css() {
    var s = document.createElement('style');
    s.textContent = '.bb-chosen{list-style:none;margin:0;padding:0;display:flex;flex-direction:column;gap:.6rem}' +
      '.bb-chosen li{display:flex;align-items:center;justify-content:space-between;gap:1rem;padding:.8rem 1.2rem;border:1px solid rgba(var(--color-foreground),.25);border-radius:6px;font-size:1.4rem;word-break:break-all}' +
      '.bb-chosen li.is-loading{opacity:.6}.bb-chosen li.is-bad{border-color:#b3261e;color:#b3261e}' +
      '.bb-chosen button{flex:none;background:none;border:0;padding:.2rem .6rem;font:inherit;font-size:1.3rem;text-decoration:underline;cursor:pointer;color:inherit}' +
      '.bb-pick{margin-top:.6rem;align-self:flex-start;min-height:4.4rem;padding:.6rem 1.8rem;border:1px solid rgb(var(--color-foreground));border-radius:999px;background:rgb(var(--color-background));color:rgb(var(--color-foreground));font:inherit;font-size:1.4rem;cursor:pointer}' +
      '.bb-link{margin-top:.8rem;display:flex;flex-direction:column;gap:.4rem}.bb-link-in{font:inherit;font-size:1.5rem;padding:1rem;border:1px solid rgba(var(--color-foreground),.55);border-radius:var(--inputs-radius,0);width:100%}' +
      '.bb-pick[hidden]{display:none}.bb-file-status{margin:.2rem 0 0}.bb-file-status.is-bad{color:#b3261e;font-weight:600}';
    (document.head || document.documentElement).appendChild(s);
  })();

  function money(p) { return '£' + (p / 100).toFixed(2); }
  function el(tag, attrs, text) {
    var e = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
        var v = attrs[k];
        if (v === true) e.setAttribute(k, '');
        else if (v !== null && v !== undefined && v !== false && v !== '') e.setAttribute(k, v);
      }
    }
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  }
  function jsonPost(url, body) {
    return origFetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() { return origFetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  /* ---------- price breaks ---------- */
  // tiers: [[minQty, 'option value'], ...] ascending. Returns the option value for a quantity.
  function bandFor(tiers, qty) {
    var v = tiers[0][1];
    for (var i = 0; i < tiers.length; i++) if (qty >= tiers[i][0]) v = tiers[i][1];
    return v;
  }
  function variantForBand(variants, band) {
    for (var i = 0; i < variants.length; i++) {
      var t = variants[i].option1 || variants[i].title;
      if (t === band) return variants[i];
    }
    return null;
  }
  var productCache = {};
  function productJson(handle) {
    if (!productCache[handle]) {
      productCache[handle] = origFetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); });
      productCache[handle].catch(function () { delete productCache[handle]; });
    }
    return productCache[handle];
  }

  /* ---------- artwork files ---------- */
  // Copy the chosen file into memory so a phone can't lose access to it before the form is sent.
  function readFile(file) {
    var rd = file.arrayBuffer ? file.arrayBuffer() : new Promise(function (ok, bad) {
      var fr = new FileReader(); fr.onload = function () { ok(fr.result); }; fr.onerror = function () { bad(fr.error); }; fr.readAsArrayBuffer(file);
    });
    return rd.then(function (buf) {
      if (!buf || !buf.byteLength) throw new Error('empty');
      return new File([buf], file.name, { type: file.type || 'application/octet-stream' });
    }).catch(function (er) {
      throw new Error("We couldn't open " + file.name + ". If it's saved in Google Drive, Google Photos or iCloud, download it to your phone first and then choose it again.");
    });
  }
  function fileField(wrap, f, i) {
    var max = f.max || 1;
    var fs = { f: f, max: max, files: [], pending: [] };
    wrap.__bbFiles = fs;
    var list = el('ul', { 'class': 'bb-chosen' });
    var inp = el('input', { type: 'file', accept: f.accept || null, multiple: max > 1, 'class': 'bb-sr', tabindex: '-1', 'aria-hidden': 'true', 'data-bb-file': '1' });
    var pick = el('button', { type: 'button', 'class': 'bb-pick', 'aria-labelledby': 'bb-lab-' + i });
    var status = el('p', { 'class': 'bb-desc bb-file-status', 'aria-live': 'polite', hidden: true });
    function say(msg, bad) { status.hidden = !msg; status.textContent = msg || ''; status.classList.toggle('is-bad', !!bad); }
    function redraw() {
      list.innerHTML = '';
      fs.files.forEach(function (item, k) {
        var li = el('li', { 'class': item.file ? '' : 'is-loading' });
        li.appendChild(el('span', null, (max > 1 ? (k + 1) + '. ' : '') + item.name + (item.file ? '' : ' – adding…')));
        var rm = el('button', { type: 'button', 'aria-label': 'Remove ' + item.name }, 'Remove');
        rm.addEventListener('click', function () { fs.files.splice(fs.files.indexOf(item), 1); say(''); redraw(); });
        li.appendChild(rm);
        list.appendChild(li);
      });
      pick.textContent = fs.files.length ? 'Add another artwork' : (max > 1 ? 'Choose artwork files' : 'Choose artwork file');
      pick.hidden = fs.files.length >= max;
    }
    pick.addEventListener('click', function () { inp.click(); });
    inp.addEventListener('change', function () {
      var picked = [].slice.call(inp.files || []);
      inp.value = '';
      if (!picked.length) return;
      var room = max - fs.files.length;
      say('');
      if (picked.length > room) say('Only ' + max + (max > 1 ? ' designs' : ' design') + ' per order – ' + (room > 0 ? 'the first ' + room + ' have been added. ' : '') + 'Add a second order to your basket for more.', true);
      var big = picked.filter(function (x) { return x.size > MAX_FILE; });
      picked = picked.filter(function (x) { return x.size <= MAX_FILE; });
      if (big.length) {
        say(big.map(function (x) { return x.name; }).join(', ') + (big.length > 1 ? ' are' : ' is') + ' over 20MB, which is the largest file our basket can take. No problem – upload ' + (big.length > 1 ? 'them' : 'it') + ' to WeTransfer (free, no account needed), Dropbox, Google Drive or OneDrive and paste the link in the box below.', true);
        if (linkIn) { linkIn.focus(); }
      }
      picked.slice(0, Math.max(room, 0)).forEach(function (file) {
        var item = { name: file.name, file: null };
        fs.files.push(item);
        var p = readFile(file).then(function (copy) { item.file = copy; }, function (er) {
          var ix = fs.files.indexOf(item); if (ix > -1) fs.files.splice(ix, 1);
          say(er.message, true);
        }).then(function () { fs.pending.splice(fs.pending.indexOf(p), 1); redraw(); });
        fs.pending.push(p);
      });
      redraw();
      wrap.dispatchEvent(new Event('change', { bubbles: true }));
    });
    wrap.appendChild(list);
    wrap.appendChild(pick);
    wrap.appendChild(inp);
    wrap.appendChild(status);
    if (f.hint) wrap.appendChild(el('p', { 'class': 'bb-desc' }, f.hint));
    var linkIn = null;
    if (f.n === 'Artwork') {
      var lw = el('div', { 'class': 'bb-link' });
      var ll = el('label', { 'for': 'bb-link-' + i, 'class': 'bb-desc' }, 'Files over 20MB? Paste a WeTransfer, Dropbox, Google Drive or OneDrive link to your artwork instead:');
      linkIn = el('input', { type: 'url', id: 'bb-link-' + i, name: 'properties[Artwork link]', placeholder: 'https://', inputmode: 'url', autocomplete: 'off', 'class': 'bb-link-in' });
      lw.appendChild(ll); lw.appendChild(linkIn);
      wrap.appendChild(lw);
      fs.link = linkIn;
    }
    redraw();
  }

  /* ---------- product page ---------- */
  function fieldWrap(f, i) {
    var wrap = el('div', { 'class': 'bb-opt bb-type-' + f.t, 'data-bb-i': String(i) });
    if (f.t === 'note') { wrap.appendChild(el('p', { 'class': 'bb-note' }, f.l)); return wrap; }
    var lab = el('p', { 'class': 'bb-label', id: 'bb-lab-' + i }, f.l);
    if (f.r) { lab.appendChild(document.createTextNode(' ')); lab.appendChild(el('span', { 'class': 'bb-req', 'aria-hidden': 'true' }, '*')); }
    wrap.appendChild(lab);
    if (f.d) wrap.appendChild(el('p', { 'class': 'bb-desc' }, f.d));
    var name = 'properties[' + f.n + ']';
    if (f.t === 'file') {
      fileField(wrap, f, i);
    } else if (f.t === 'textarea') {
      wrap.appendChild(el('textarea', { name: name, rows: '4', maxlength: f.max || null, required: !!f.r, 'aria-labelledby': 'bb-lab-' + i, 'data-bb-in': '1' }));
    } else if (f.t === 'select') {
      // Shown as buttons; a hidden select keeps the value for the order.
      var sel = el('select', { name: name, required: !!f.r, 'class': 'bb-sr', tabindex: '-1', 'aria-hidden': 'true', 'data-bb-in': '1' });
      sel.appendChild((function () { var o = el('option', null, 'Please choose'); o.setAttribute('value', ''); return o; })());
      var pills = el('div', { 'class': 'bb-pills', role: 'group', 'aria-labelledby': 'bb-lab-' + i });
      f.o.forEach(function (v) {
        sel.appendChild(el('option', { value: v[0] }, v[0]));
        var b = el('button', { type: 'button', 'class': 'bb-pill', 'aria-pressed': 'false', 'data-v': v[0] }, v[0] + (v[1] ? ' (+' + money(v[1].p) + (v[1].once ? '' : ' each') + ')' : ''));
        b.addEventListener('click', function () { sel.value = v[0]; sel.dispatchEvent(new Event('change', { bubbles: true })); });
        pills.appendChild(b);
      });
      sel.addEventListener('change', function () {
        var bs = pills.querySelectorAll('.bb-pill');
        for (var k = 0; k < bs.length; k++) bs[k].setAttribute('aria-pressed', bs[k].getAttribute('data-v') === sel.value ? 'true' : 'false');
      });
      sel.__bbPills = pills;
      wrap.appendChild(pills);
      wrap.appendChild(sel);
    } else if (f.t === 'checkboxes') {
      var hid = el('input', { type: 'hidden', name: name, disabled: true, 'data-bb-group': '1' });
      var g = el('div', { 'class': 'bb-checks', role: 'group', 'aria-labelledby': 'bb-lab-' + i });
      f.o.forEach(function (v) {
        var l = el('label', { 'class': 'bb-check' });
        l.appendChild(el('input', { type: 'checkbox', value: v }));
        l.appendChild(document.createTextNode(' ' + v));
        g.appendChild(l);
      });
      g.addEventListener('change', function () {
        var vals = [].slice.call(g.querySelectorAll('input:checked')).map(function (x) { return x.value; });
        hid.value = vals.join(', '); hid.disabled = !vals.length;
      });
      wrap.appendChild(g); wrap.appendChild(hid);
    } else if (f.t === 'agree') {
      var l2 = el('label', { 'class': 'bb-check' });
      l2.appendChild(el('input', { type: 'checkbox', name: name, value: 'Yes', required: !!f.r, 'data-bb-in': '1' }));
      l2.appendChild(document.createTextNode(' ' + f.text));
      wrap.appendChild(l2);
    }
    return wrap;
  }

  function fieldValue(st, i) {
    var w = st.box.querySelector('[data-bb-i="' + i + '"]');
    var s = w && w.querySelector('select, textarea, input[data-bb-in]');
    return s ? (s.type === 'checkbox' ? (s.checked ? s.value : '') : s.value) : '';
  }
  function applyDeps(st) {
    st.cfg.fields.forEach(function (f, i) {
      if (!f.show) return;
      var pw = st.box.querySelector('[data-bb-i="' + f.show[0] + '"]');
      var on = !(pw && pw.hidden) && fieldValue(st, f.show[0]) === f.show[1];
      var w = st.box.querySelector('[data-bb-i="' + i + '"]');
      w.hidden = !on;
      [].forEach.call(w.querySelectorAll('input, select, textarea'), function (x) {
        if (x.getAttribute('data-bb-group')) return;
        x.disabled = !on;
      });
    });
  }
  // Paid extras for the current choices: [{v: variantId, p: pence, once: bool, n, val}]
  function extras(st) {
    var out = [];
    st.cfg.fields.forEach(function (f, i) {
      if (f.t !== 'select') return;
      var w = st.box.querySelector('[data-bb-i="' + i + '"]');
      if (w.hidden) return;
      var val = fieldValue(st, i);
      f.o.forEach(function (v) { if (v[0] === val && v[1]) out.push({ v: v[1].v, p: v[1].p, once: !!v[1].once, n: f.n, val: val }); });
    });
    return out;
  }
  function fileFields(st) {
    return [].filter.call(st.box.querySelectorAll('.bb-type-file'), function (w) { return w.__bbFiles && !w.hidden; });
  }

  function qtyInput(st) { return st.form.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + st.form.getAttribute('id') + '"]'); }
  function chosenQty(st) { var q = qtyInput(st); return Math.max(1, parseInt(q && q.value, 10) || 1); }

  var VAT = window.BB_VAT_NOTE === undefined ? ' + VAT' : window.BB_VAT_NOTE;
  function setQty(st, n) {
    var q = qtyInput(st);
    if (!q) return;
    q.value = Math.max(n, st.cfg.minQty || 1);
    q.dispatchEvent(new Event('change', { bubbles: true }));
    updatePrice(st);
  }
  function unitWord(st, n) {
    var u = st.cfg.unit || '';
    return n === 1 ? (st.cfg.unitOne || (/ses$/.test(u) ? u.replace(/es$/, '') : u.replace(/s$/, ''))) : u;
  }

  function updatePrice(st) {
    var qty = chosenQty(st);
    var already = st.inCart || 0;
    var line = '', total = 0, unitPrice = 0, nudge = null;
    if (st.cfg.tiers && st.product) {
      var band = bandFor(st.cfg.tiers, qty + already);
      var v = variantForBand(st.product.variants, band);
      if (v) {
        unitPrice = v.price;
        total = v.price * qty;
        line = money(v.price) + ' each' + VAT;
      }
      [].forEach.call(st.box.querySelectorAll('.bb-tier'), function (row) {
        var on = row.getAttribute('data-band') === band;
        row.classList.toggle('is-current', on);
        row.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      // next price break
      for (var i = 0; i < st.cfg.tiers.length; i++) {
        var tr = st.cfg.tiers[i];
        if (tr[0] > qty + already) {
          var nv = variantForBand(st.product.variants, tr[1]);
          if (nv && v && nv.price < v.price) nudge = { add: tr[0] - (qty + already), price: nv.price, to: qty + (tr[0] - (qty + already)) };
          break;
        }
      }
    } else if (st.product) {
      unitPrice = st.product.variants[0].price;
      total = unitPrice * qty; line = money(unitPrice) + ' each' + VAT;
    }
    var ex = extras(st), exTotal = 0;
    ex.forEach(function (x) { exTotal += x.once ? x.p : x.p * qty; });
    st.priceEl.innerHTML = '';
    if (line) {
      st.priceEl.appendChild(el('span', { 'class': 'bb-price-each' }, line));
      var t = qty + ' ' + unitWord(st, qty) + ': ' + money(total + exTotal) + VAT;
      if (exTotal) t += ' (includes ' + money(exTotal) + ' extras)';
      if (already) t += ' · price includes the ' + already + ' already in your basket';
      st.priceEl.appendChild(el('span', { 'class': 'bb-price-total' }, t));
    }
    if (st.nudgeEl) {
      st.nudgeEl.innerHTML = '';
      st.nudgeEl.hidden = !nudge;
      if (nudge) {
        st.nudgeEl.appendChild(document.createTextNode('Add ' + nudge.add + ' more and pay '));
        st.nudgeEl.appendChild(el('strong', null, money(nudge.price) + ' each'));
        st.nudgeEl.appendChild(document.createTextNode(' '));
        var b = el('button', { type: 'button', 'class': 'bb-nudge-btn' }, 'Make it ' + nudge.to);
        b.addEventListener('click', function () { setQty(st, nudge.to); });
        st.nudgeEl.appendChild(b);
      }
    }
    if (st.sticky) {
      st.sticky.querySelector('.bb-sticky-price').textContent = line ? money(total + exTotal) + VAT : '';
      st.sticky.querySelector('.bb-sticky-sub').textContent = line ? qty + ' ' + unitWord(st, qty) + ' · ' + money(unitPrice) + ' each' : '';
    }
  }

  function render(st) {
    var box = el('div', { 'class': 'bb-options' });
    st.box = box;
    if (st.cfg.tiers) {
      var t = el('div', { 'class': 'bb-tiers' });
      var head = el('div', { 'class': 'bb-tiers-head' });
      head.appendChild(el('p', { 'class': 'bb-label' }, 'Price breaks'));
      head.appendChild(el('p', { 'class': 'bb-desc' }, (st.cfg.mixNote || 'The more you order, the less you pay.') + ' Tap a price break to choose it.'));
      t.appendChild(head);
      var tb = el('div', { 'class': 'bb-tier-list', role: 'group', 'aria-label': 'Price breaks' });
      var base = null;
      st.cfg.tiers.forEach(function (tr) {
        var v = st.product && variantForBand(st.product.variants, tr[1]);
        if (!v) return;
        if (base === null) base = v.price;
        var row = el('button', { type: 'button', 'class': 'bb-tier', 'data-band': tr[1], 'aria-pressed': 'false' });
        row.appendChild(el('span', { 'class': 'bb-tier-qty' }, tr[1]));
        row.appendChild(el('span', { 'class': 'bb-tier-price' }, money(v.price)));
        var save = base ? Math.round((1 - v.price / base) * 100) : 0;
        row.appendChild(el('span', { 'class': 'bb-tier-save' }, save > 0 ? 'Save ' + save + '%' : 'each'));
        row.addEventListener('click', function () { setQty(st, Math.max(tr[0] - (st.inCart || 0), 1)); });
        tb.appendChild(row);
      });
      t.appendChild(tb);
      t.appendChild(el('p', { 'class': 'bb-desc bb-tier-foot' }, 'Prices per ' + unitWord(st, 1) + VAT + '.'));
      box.appendChild(t);
      st.qtySlot = el('div', { 'class': 'bb-qty-slot' });
      box.appendChild(st.qtySlot);
      st.nudgeEl = el('p', { 'class': 'bb-nudge', hidden: true });
      box.appendChild(st.nudgeEl);
    }
    st.cfg.fields.forEach(function (f, i) { box.appendChild(fieldWrap(f, i)); });
    st.priceEl = el('p', { 'class': 'bb-price', 'aria-live': 'polite' });
    box.appendChild(st.priceEl);
    box.appendChild(el('p', { 'class': 'bb-error', role: 'alert', hidden: true }));
    return box;
  }

  function showError(st, msg) {
    var e = st.box.querySelector('.bb-error');
    e.hidden = !msg; e.textContent = msg || '';
    var pf = st.form.closest('product-form');
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    var m = wrap && wrap.querySelector('.product-form__error-message');
    if (wrap && m) { if (msg) wrap.removeAttribute('hidden'); else wrap.setAttribute('hidden', ''); m.textContent = msg || ''; }
  }
  function setLoading(btn, on) {
    if (!btn) return;
    var sp = btn.querySelector('.loading__spinner, .loading-overlay__spinner');
    if (on) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); if (sp) sp.classList.remove('hidden'); }
    else { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); if (sp) sp.classList.add('hidden'); }
  }
  function cartSections(cart) {
    try { return cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : []; } catch (e) { return []; }
  }

  function validate(st) {
    var fields = st.box.querySelectorAll('input, select, textarea');
    for (var q = 0; q < fields.length; q++) {
      var x = fields[q];
      if (x.disabled || x.type === 'hidden' || x.type === 'file' || x.checkValidity()) continue;
      var w = x.closest('.bb-opt'); var lb = w && w.querySelector('.bb-label');
      if (x.__bbPills) { showError(st, 'Please choose: ' + (lb ? lb.textContent.replace(/\s*\*$/, '') : 'an option')); x.__bbPills.querySelector('.bb-pill').focus(); }
      else { x.reportValidity(); }
      return false;
    }
    var ok = true;
    fileFields(st).forEach(function (w) {
      if (!ok) return;
      var fs = w.__bbFiles;
      var hasLink = fs.link && /^https?:\/\/\S+\.\S+/i.test(fs.link.value.trim());
      if (fs.link && fs.link.value.trim() && !hasLink) {
        ok = false;
        showError(st, 'Please paste the full link to your artwork, starting with https://');
        fs.link.focus();
        return;
      }
      if (fs.f.r && !fs.files.length && !hasLink) {
        ok = false;
        showError(st, fs.max > 1 ? 'Please add your artwork (up to ' + fs.max + ' files).' : 'Please add your artwork.');
        var b = w.querySelector('.bb-pick'); if (b) b.focus();
      }
    });
    st.cfg.fields.forEach(function (f, i) {
      if (f.t !== 'checkboxes' || !f.r || !ok) return;
      var w = st.box.querySelector('[data-bb-i="' + i + '"]');
      if (w.hidden) return;
      if (!w.querySelector('input:checked')) { ok = false; showError(st, 'Please tick at least one: ' + f.l); }
    });
    return ok;
  }

  // POST the add-to-cart form; one automatic retry if the connection drops.
  function postAdd(url, fd, tries) {
    return origFetch(url, { method: 'POST', credentials: 'same-origin', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' } })
      .then(function (r) {
        return r.text().then(function (txt) {
          try { return JSON.parse(txt); } catch (e) {
            if (r.status === 413) throw new Error('Your artwork files are too large to upload together. Please add fewer files, or email them to sales@beerbadges.co.uk and we\'ll sort it for you.');
            throw new Error('Sorry, this could not be added to your basket (' + r.status + '). Please try again, or email us at sales@beerbadges.co.uk.');
          }
        });
      }, function (er) {
        if (tries > 0) return new Promise(function (ok) { setTimeout(ok, 1500); }).then(function () { return postAdd(url, fd, tries - 1); });
        throw new Error(NET_MSG);
      });
  }

  function submit(st) {
    var form = st.form;
    var btn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    showError(st, null);
    if (!validate(st)) return;
    var qty = chosenQty(st);
    var ex = extras(st);
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    setLoading(btn, true);
    var mainItem = null;
    var waits = [];
    fileFields(st).forEach(function (w) { waits = waits.concat(w.__bbFiles.pending); });
    Promise.all(waits).then(function () {
      if (!validate(st)) throw new Error('');
      return st.cfg.tiers ? getCart() : null;
    }).then(function (c) {
      var fd = new FormData(form);
      [].forEach.call(form.querySelectorAll('input[type=file]'), function (x) { if (x.name) fd.delete(x.name); });
      if (!String(fd.get('properties[Artwork link]') || '').trim()) fd.delete('properties[Artwork link]');
      fileFields(st).forEach(function (w) {
        var fs = w.__bbFiles;
        fs.files.forEach(function (item, k) {
          if (!item.file) return;
          fd.append(fs.max > 1 ? 'properties[' + fs.f.n + ' ' + (k + 1) + ']' : 'properties[' + fs.f.n + ']', item.file, item.file.name);
        });
      });
      if (st.cfg.tiers && st.product) {
        var already = 0;
        (c && c.items || []).forEach(function (it) { if (it.product_id === st.product.id) already += it.quantity; });
        var v = variantForBand(st.product.variants, bandFor(st.cfg.tiers, already + qty));
        if (v) fd.set('id', String(v.id));
      }
      var addUrl = (window.routes && window.routes.cart_add_url) || (root + 'cart/add');
      return postAdd(addUrl, fd, 1);
    }).then(function (item) {
      if (item.status) throw new Error(item.description || item.message || 'Sorry, this could not be added to your basket.');
      mainItem = item;
      if (!ex.length) return null;
      var items = ex.map(function (x) {
        var it = { id: x.v, quantity: x.once ? 1 : qty, parent_line_key: item.key, properties: {} };
        it.properties[x.once ? '_bb_once' : '_bb_per'] = '1';
        return it;
      });
      return jsonPost(root + 'cart/add.js', { items: items }).then(function (res) {
        if (res.status) {
          return jsonPost(root + 'cart/change.js', { id: item.key, quantity: Math.max(0, item.quantity - qty) })
            .then(function () { throw new Error(res.description || 'Sorry, the selected extras could not be added.'); });
        }
      });
    }).then(function () { return reconcile(true); })
      .then(function () {
        var sections = cartSections(cart);
        if (!cart || !sections.length) { location.href = (window.routes && window.routes.cart_url) || (root + 'cart'); return; }
        return origFetch(root + '?sections=' + sections.join(','), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (secs) {
          return getCart().then(function (c) {
            var line = null;
            (c.items || []).forEach(function (it) { if (it.product_id === st.product.id && !line) line = it; });
            var state = line || mainItem; state = JSON.parse(JSON.stringify(state)); state.sections = secs;
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            try { cart.renderContents(state); } catch (e) { location.href = root + 'cart'; }
            try { if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: state.variant_id, cartData: c }); } catch (e) { /* ignore */ }
            st.inCart = 0; (c.items || []).forEach(function (it) { if (it.product_id === st.product.id) st.inCart += it.quantity; });
            updatePrice(st);
          });
        });
      })
      .catch(function (er) {
        var msg = (er && er.message) || String(er);
        if (er instanceof TypeError || /failed to fetch|load failed|networkerror/i.test(msg)) msg = NET_MSG;
        if (msg) showError(st, msg);
      })
      .then(function () { setLoading(btn, false); });
  }

  function findForm() {
    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"], form[action$="/cart/add"]');
    var fallback = null;
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('quick-add-modal, .quick-add-modal, product-modal, .product-popup-modal')) continue;
      var fid = f.getAttribute('id') || '';
      if (/installment/.test(fid)) continue;
      if (/^product-form-template/.test(fid) || f.getAttribute('data-type') === 'add-to-cart-form') return f;
      if (!fallback && f.closest('product-info, .product')) fallback = f;
    }
    return fallback;
  }

  var state = null;
  function mount() {
    var prod = window.BB_PRODUCT;
    if (!prod || !CFG[prod.handle]) return;
    var form = findForm();
    if (!form) return;
    if (state && state.form === form && state.box.isConnected) return;
    var st = { form: form, cfg: CFG[prod.handle], product: prod, inCart: 0 };
    var box = render(st);
    var anchor = form.querySelector('.product-form__buttons');
    if (anchor && anchor.parentNode === form) form.insertBefore(box, anchor);
    else if (anchor) anchor.parentNode.insertBefore(box, anchor);
    else form.appendChild(box);
    var pay = form.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout');
    for (var p = 0; p < pay.length; p++) pay[p].style.display = 'none';
    // quantity selector sits under the price breaks
    var qwrap = document.querySelector('.product-form__quantity');
    if (st.qtySlot && qwrap) st.qtySlot.appendChild(qwrap);
    // mobile sticky bar: shows the running total and takes the customer back to the options
    var btn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    if (btn && 'IntersectionObserver' in window && !document.querySelector('.bb-sticky')) {
      var bar = el('div', { 'class': 'bb-sticky', 'aria-hidden': 'true' });
      var info = el('div', { 'class': 'bb-sticky-info' });
      info.appendChild(el('span', { 'class': 'bb-sticky-price' }));
      info.appendChild(el('span', { 'class': 'bb-sticky-sub' }));
      bar.appendChild(info);
      var go = el('button', { type: 'button', 'class': 'bb-sticky-btn', tabindex: '-1' }, 'Order now');
      go.addEventListener('click', function () { box.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      bar.appendChild(go);
      document.body.appendChild(bar);
      st.sticky = bar;
      new IntersectionObserver(function (en) {
        var e = en[0];
        bar.classList.toggle('is-on', !e.isIntersecting);
      }).observe(box);
    }
    box.addEventListener('change', function () { applyDeps(st); updatePrice(st); });
    box.addEventListener('input', function () { updatePrice(st); });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'quantity') updatePrice(st); });
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('quantity-input')) setTimeout(function () { updatePrice(st); }, 50); });
    var q = qtyInput(st);
    if (q && st.cfg.minQty) { q.min = st.cfg.minQty; if ((parseInt(q.value, 10) || 0) < st.cfg.minQty) q.value = st.cfg.minQty; }
    form.__bb = st;
    state = st;
    applyDeps(st);
    getCart().then(function (c) { (c.items || []).forEach(function (it) { if (it.product_id === prod.id) st.inCart += it.quantity; }); updatePrice(st); }).catch(function () { updatePrice(st); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.__bb) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    submit(form.__bb);
  }, true);

  /* ---------- basket: right price break for the total quantity, extras follow their product ---------- */
  var reconciling = null, again = false;
  function reconcile(silent) {
    if (reconciling) { again = true; return reconciling; }
    reconciling = getCart().then(function (cart) {
      var items = cart.items || [];
      var byKey = {}, totals = {}, changed = false;
      items.forEach(function (it) { byKey[it.key] = it; if (!(it.parent_relationship && it.parent_relationship.parent_key)) totals[it.product_id] = (totals[it.product_id] || 0) + it.quantity; });
      var jobs = [];
      // 1) price breaks
      items.forEach(function (it) {
        var cfg = CFG[it.handle];
        if (!cfg || !cfg.tiers || (it.parent_relationship && it.parent_relationship.parent_key)) return;
        var band = bandFor(cfg.tiers, totals[it.product_id]);
        var cur = it.variant_options && it.variant_options[0];
        if (cur === band) return;
        jobs.push(function () {
          return productJson(it.handle).then(function (p) {
            var v = variantForBand(p.variants, band);
            if (!v || v.id === it.variant_id) return;
            var kids = items.filter(function (k) { return k.parent_relationship && k.parent_relationship.parent_key === it.key; });
            var props = {}; for (var pk in (it.properties || {})) if (it.properties[pk] !== null && it.properties[pk] !== '') props[pk] = it.properties[pk];
            return jsonPost(root + 'cart/add.js', { items: [{ id: v.id, quantity: it.quantity, properties: props }] }).then(function (res) {
              if (res.status || !res.items || !res.items[0]) return;
              var nk = res.items[0].key;
              var p2 = kids.length ? jsonPost(root + 'cart/add.js', { items: kids.map(function (k) { return { id: k.variant_id, quantity: k.quantity, parent_line_key: nk, properties: k.properties || {} }; }) }) : Promise.resolve();
              return p2.then(function () { return jsonPost(root + 'cart/change.js', { id: it.key, quantity: 0 }); }).then(function () { changed = true; });
            });
          });
        });
      });
      return jobs.reduce(function (pr, j) { return pr.then(j); }, Promise.resolve()).then(function () {
        return changed ? getCart() : cart;
      }).then(function (c2) {
        // 2) extras follow their product's quantity
        var bk = {}, fixes = [];
        (c2.items || []).forEach(function (it) { bk[it.key] = it; });
        (c2.items || []).forEach(function (it) {
          var props = it.properties || {};
          if (!props._bb_per && !props._bb_once) return;
          var pk = it.parent_relationship && it.parent_relationship.parent_key;
          var parent = pk ? bk[pk] : null;
          var want = parent ? (props._bb_once ? 1 : parent.quantity) : 0;
          if (it.quantity !== want) fixes.push({ id: it.key, quantity: want });
        });
        return fixes.reduce(function (pr, f) { return pr.then(function () { changed = true; return jsonPost(root + 'cart/change.js', f); }); }, Promise.resolve());
      }).then(function () { return changed; });
    }).then(function (changed) {
      if (!changed || silent) return changed;
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return changed; }
      var cd = document.querySelector('cart-drawer');
      var ids = cartSections(cd);
      if (!cd || !ids.length) return changed;
      return origFetch(root + '?sections=' + ids.join(','), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (secs) {
        ids.forEach(function (id) {
          var s = cd.getSectionsToRender().filter(function (x) { return x.id === id; })[0];
          var target = s && s.selector ? document.querySelector(s.selector) : document.getElementById(id);
          if (target && secs[id] && cd.getSectionInnerHTML) target.innerHTML = cd.getSectionInnerHTML(secs[id], s && s.selector);
        });
        return changed;
      });
    }).catch(function () { return false; }).then(function (r) {
      reconciling = null;
      if (again) { again = false; setTimeout(function () { reconcile(); }, 100); }
      return r;
    });
    return reconciling;
  }
  window.bbReconcile = reconcile;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var pr = origFetch(input, init);
    if (/\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) pr.then(function () { setTimeout(function () { reconcile(); }, 300); }, function () {});
    return pr;
  };

  function start() {
    mount();
    setInterval(mount, 1500);
    reconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
